/* =====================================================================
   EurekaPAES Buscador — Módulo Extras v6
   Quick wins + features comerciales + ux complementaria
   Sub-módulos en este archivo:
     EpUrl       → URL deeplink (?carrera, ?favs)
     EpRecientes → Vistas recientes (localStorage)
     EpOnboard   → Onboarding 3 pasos primera visita
     EpTooltip   → Tooltips de términos PAES (hover/tap)
     EpGlosario  → Modal glosario completo
     EpAlcanzo   → Filtro "alcanzo hoy"
     EpShareWA   → Compartir favoritas por WhatsApp
     EpAlt       → Carreras alternativas/similares en modal
     EpCTA       → CTA inteligente según prueba urgente
     EpClaseGratis → Banner clase gratis en modal
     EpInforme   → Generar informe imprimible (window.print)
     EpPopulares → Marcar carreras con más vacantes
     EpBuscaInt  → Sugerencias relacionadas (Quiero estudiar Medicina → )
   Todo expuesto bajo window.EpExtras.{...}
   ===================================================================== */
(function () {
  'use strict';

  var LS = {
    RECIENTES:  'ep_paes_recientes_v1',
    ONBOARD:    'ep_paes_onboard_v1',
    ALCANZO:    'ep_paes_alcanzo_v1'
  };
  var WA_LINK = 'https://www.eurekapaes.cl/'; /* link base para WhatsApp share */
  var PREU_LINK = 'https://www.eurekapaes.cl/collections/preu';
  var CLASE_GRATIS_LINK = 'https://www.eurekapaes.cl/apps/preu-online/course/697e851c9a810af81dcc7d63';

  /* ============ UTIL COMPARTIDOS ============ */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'class') n.className = v;
      else if (k === 'text') n.textContent = v;
      else if (k === 'html') n.innerHTML = v;
      else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.substring(2), v);
      else n.setAttribute(k, v);
    }
    if (children) {
      if (!Array.isArray(children)) children = [children];
      children.forEach(function (c) {
        if (c == null || c === false) return;
        if (typeof c === 'string') n.appendChild(document.createTextNode(c));
        else n.appendChild(c);
      });
    }
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
  }
  function dataArr() { return (window.EP_PAES_DATA && Array.isArray(window.EP_PAES_DATA)) ? window.EP_PAES_DATA : []; }
  function findByCode(cod) {
    var a = dataArr();
    for (var i = 0; i < a.length; i++) if (a[i].codigo_demre === cod) return a[i];
    return null;
  }
  function fmtNum(p) {
    if (p == null) return '—';
    return (typeof p === 'number' && p % 1 !== 0) ? p.toFixed(1) : String(p);
  }
  function readJSON(k, def) { try { return JSON.parse(localStorage.getItem(k)) || def; } catch (e) { return def; } }
  function writeJSON(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ============ EpUrl — Deeplinking ?carrera / ?favs ============ */
  var EpUrl = (function () {
    function getQuery() {
      var p = {};
      window.location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
        if (!kv) return;
        var i = kv.indexOf('=');
        if (i < 0) p[decodeURIComponent(kv)] = '';
        else p[decodeURIComponent(kv.substring(0, i))] = decodeURIComponent(kv.substring(i + 1));
      });
      return p;
    }
    function setParam(key, value) {
      var q = getQuery();
      if (value == null || value === '') delete q[key];
      else q[key] = value;
      var str = Object.keys(q).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(q[k]); }).join('&');
      var url = window.location.pathname + (str ? '?' + str : '') + window.location.hash;
      try { window.history.replaceState({}, '', url); } catch (e) {}
    }
    function handleInitial() {
      var q = getQuery();
      /* SEC: validación estricta de parámetros URL. Sólo se aceptan códigos
         DEMRE de 5 dígitos. Cualquier otro carácter (incluyendo HTML, scripts,
         payloads XSS) se descarta sin renderizar nada. */
      var DEMRE_RE = /^\d{5}$/;
      var MAX_FAVS_FROM_URL = 50;

      /* ?favs= código,código,código → mergea con favoritos existentes */
      if (q.favs && (typeof localStorage !== 'undefined')) {
        /* Limitamos largo del parámetro para evitar abuso (50 códigos de 5 dígitos + comas = ~300 chars) */
        var favsRaw = String(q.favs).slice(0, 400);
        var codes = favsRaw.split(',')
          .map(function (s) { return String(s).trim(); })
          .filter(function (s) { return DEMRE_RE.test(s); })
          .slice(0, MAX_FAVS_FROM_URL);
        if (codes.length) {
          try {
            var raw = localStorage.getItem('ep_paes_favs_v1');
            var current = raw ? JSON.parse(raw) : [];
            if (!Array.isArray(current)) current = [];
            /* Saneamos los actuales también */
            var seen = {};
            var merged = [];
            current.concat(codes).forEach(function (c) {
              if (typeof c !== 'string' || !DEMRE_RE.test(c)) return;
              if (seen[c]) return;
              seen[c] = 1;
              if (merged.length < 100) merged.push(c);
            });
            localStorage.setItem('ep_paes_favs_v1', JSON.stringify(merged));
          } catch (e) {}
        }
      }
      /* ?carrera= código → abrir modal sólo si el código tiene formato válido
         y existe en el dataset. Cualquier otro valor se ignora silenciosamente. */
      if (q.carrera && DEMRE_RE.test(String(q.carrera))) {
        var codigoBuscado = String(q.carrera);
        var tryOpen = function () {
          var c = findByCode(codigoBuscado);
          if (c && window.EpPaesAbrirModal) {
            window.EpPaesAbrirModal(c);
            return true;
          }
          return false;
        };
        var attempts = 0;
        var t = setInterval(function () {
          if (tryOpen() || ++attempts > 30) clearInterval(t);
        }, 200);
      }
    }
    return { getQuery: getQuery, setParam: setParam, handleInitial: handleInitial };
  })();

  /* ============ EpRecientes ============ */
  var EpRecientes = (function () {
    var MAX = 10;
    function load() { return readJSON(LS.RECIENTES, []); }
    function save(arr) { writeJSON(LS.RECIENTES, arr); }
    function add(codigo) {
      if (!codigo) return;
      var arr = load();
      arr = arr.filter(function (c) { return c !== codigo; });
      arr.unshift(codigo);
      if (arr.length > MAX) arr = arr.slice(0, MAX);
      save(arr); render();
    }
    function clear() { save([]); render(); }
    function render() {
      var host = $('#ep-paes-recientes');
      if (!host) return;
      var arr = load();
      host.innerHTML = '';
      if (!arr.length) return;
      var carreras = arr.map(findByCode).filter(Boolean);
      if (!carreras.length) return;
      var box = el('section', { class: 'ep-paes-recientes' });
      var head = el('div', { class: 'ep-paes-recientes-head' });
      head.appendChild(el('h3', { class: 'ep-paes-recientes-title', html: '🕒 Vistas recientes' }));
      head.appendChild(el('button', { type: 'button', class: 'ep-paes-recientes-clear', text: '✕ Limpiar', onclick: function () { clear(); } }));
      box.appendChild(head);
      var list = el('div', { class: 'ep-paes-recientes-list' });
      carreras.slice(0, MAX).forEach(function (c) {
        var card = el('div', { class: 'ep-paes-recientes-card' });
        card.appendChild(el('div', { class: 'rec-titulo', text: c.carrera }));
        card.appendChild(el('div', { class: 'rec-uni', text: c.universidad }));
        card.appendChild(el('div', { class: 'rec-meta', text: '#' + c.codigo_demre + (c.region ? ' · ' + c.region : '') }));
        card.appendChild(el('button', {
          type: 'button', class: 'rec-btn', text: 'Ver',
          onclick: function () { if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(c); }
        }));
        list.appendChild(card);
      });
      box.appendChild(list);
      host.appendChild(box);
    }
    return { add: add, render: render };
  })();

  /* ============ EpOnboard — Tour de 3 pasos ============ */
  var EpOnboard = (function () {
    function shouldShow() { return !localStorage.getItem(LS.ONBOARD); }
    function mark() { try { localStorage.setItem(LS.ONBOARD, '1'); } catch (e) {} }
    function show() {
      if ($('#ep-paes-onboard')) return;
      var overlay = el('div', { id: 'ep-paes-onboard', class: 'ep-paes-onboard-overlay ep-paes-root' });
      var box = el('div', { class: 'ep-paes-onboard-box' });
      var ohead = el('div', { class: 'ep-paes-dialog-header' });
      ohead.appendChild(el('span', { class: 'ep-paes-onboard-step ep-paes-dialog-chip', text: 'Bienvenida EurekaPAES' }));
      ohead.appendChild(el('h2', { text: '¡Bienvenido al Buscador PAES 2026!' }));
      ohead.appendChild(el('p', { class: 'ep-paes-onboard-intro', text: 'En 3 pasos vas a tener tu plan PAES personalizado.' }));
      box.appendChild(ohead);
      var steps = el('div', { class: 'ep-paes-onboard-steps' });
      [
        { n: '🔎', t: 'Busca tu carrera', s: 'Filtra por universidad, región o área. Tenemos 2.150 carreras DEMRE.' },
        { n: '⭐', t: 'Marca con estrella tus favoritas', s: 'Toca la estrella en cualquier carrera para guardarla.' },
        { n: '🧠', t: 'Ingresa tus puntajes', s: 'Verás tu puntaje ponderado en cada favorita y qué prueba reforzar.' }
      ].forEach(function (s) {
        steps.appendChild(el('div', { class: 'ep-paes-onboard-step-item' }, [
          el('div', { class: 'icon', text: s.n }),
          el('div', { class: 'body' }, [
            el('div', { class: 'tit', text: s.t }),
            el('div', { class: 'sub', text: s.s })
          ])
        ]));
      });
      box.appendChild(steps);
      var actions = el('div', { class: 'ep-paes-onboard-actions' });
      actions.appendChild(el('button', {
        type: 'button', class: 'ep-paes-onboard-skip',
        text: 'No volver a mostrar',
        onclick: function () { mark(); overlay.remove(); }
      }));
      actions.appendChild(el('button', {
        type: 'button', class: 'ep-paes-onboard-go',
        text: 'Entendido, comenzar 🚀',
        onclick: function () { mark(); overlay.remove(); }
      }));
      box.appendChild(actions);
      overlay.appendChild(box);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) { mark(); overlay.remove(); } });
      document.body.appendChild(overlay);
    }
    function init() { if (shouldShow()) setTimeout(show, 800); }
    return { init: init, showAgain: show };
  })();

  /* ============ EpTooltip — Tooltips PAES ============ */
  var EpTooltip = (function () {
    var DEFS = {
      'nem':       { t: 'NEM', d: 'Promedio de Notas de Enseñanza Media transformado a puntaje (150–1000). Es uno de los factores ponderados por las universidades.' },
      'ranking':   { t: 'Ranking', d: 'Puntaje que premia tu posición dentro de tu colegio de egreso (150–1000). Compara tu rendimiento con tus pares.' },
      'clec':      { t: 'CLEC (Competencia Lectora)', d: 'Prueba obligatoria PAES que mide comprensión lectora. Su puntaje se usa para el "puntaje de corte CLEC + M1".' },
      'm1':        { t: 'Matemática M1', d: 'Prueba obligatoria PAES de matemática. Se rinde junto con CLEC y juntas forman el promedio "obligatorias".' },
      'm2':        { t: 'Matemática M2', d: 'Prueba electiva de matemática avanzada. Algunas carreras la exigen o ponderan.' },
      'pace':      { t: 'PACE', d: 'Programa de Acompañamiento y Acceso Efectivo. Permite ingresar a algunas carreras por una vía especial para estudiantes destacados de colegios PACE.' },
      'vacantes':  { t: 'Vacantes', d: 'Cantidad de cupos que la carrera ofrece por vía regular (primer + segundo semestre).' },
      'codigo':    { t: 'Código DEMRE', d: 'Identificador único que asigna DEMRE a cada combinación carrera-universidad-sede. Cada sede tiene un código distinto.' },
      'corte':     { t: 'Puntaje de corte ponderado', d: 'Menor puntaje ponderado entre quienes se matricularon en la carrera vía regular. Calculado desde datos oficiales DEMRE y validado contra portales universitarios.' },
      'clecm1':    { t: 'Promedio CLEC + M1', d: 'Promedio aritmético de las pruebas obligatorias del último seleccionado. Es el dato oficial DEMRE; lo usamos como referencia cuando no hay puntaje ponderado.' },
      'pondmin':   { t: 'Puntaje ponderado mínimo', d: 'Piso de puntaje ponderado para poder postular a la carrera. No garantiza selección, solo permite postular.' },
      'electiva':  { t: 'Electiva Ciencias / Historia', d: 'Cuando la carrera pondera Ciencias e Historia con el mismo porcentaje, no se suman. El sistema usa automáticamente la prueba que más te favorece.' },
      'percentil': { t: 'Percentil', d: 'Indica qué porcentaje de seleccionados tiene puntaje igual o menor al valor. P50 = mediana. P90 = solo el 10% supera ese puntaje.' },
      'ponderacion': { t: 'Ponderación', d: 'Porcentaje con que cada prueba/factor pesa en el cálculo del puntaje ponderado. La suma da 100%.' }
    };
    var tip = null;
    function getTip() {
      if (!tip) {
        tip = el('div', { class: 'ep-paes-tooltip' });
        document.body.appendChild(tip);
      }
      return tip;
    }
    function showFor(target) {
      var key = target.getAttribute('data-tip');
      var def = DEFS[key];
      if (!def) return;
      var t = getTip();
      t.innerHTML = '<div class="tip-t">' + escapeHtml(def.t) + '</div><div class="tip-d">' + escapeHtml(def.d) + '</div>';
      var rect = target.getBoundingClientRect();
      var top = window.pageYOffset + rect.bottom + 6;
      var left = window.pageXOffset + rect.left;
      var maxLeft = window.pageXOffset + window.innerWidth - 280;
      if (left > maxLeft) left = maxLeft;
      if (left < 8) left = 8;
      t.style.top = top + 'px';
      t.style.left = left + 'px';
      t.classList.add('is-open');
    }
    function hide() { var t = getTip(); t.classList.remove('is-open'); }
    function init() {
      document.addEventListener('mouseover', function (e) {
        var tg = e.target.closest && e.target.closest('[data-tip]');
        if (tg) showFor(tg);
      });
      document.addEventListener('mouseout', function (e) {
        var tg = e.target.closest && e.target.closest('[data-tip]');
        if (tg) hide();
      });
      document.addEventListener('click', function (e) {
        var tg = e.target.closest && e.target.closest('[data-tip]');
        if (tg) { e.stopPropagation(); showFor(tg); setTimeout(hide, 3500); }
        else hide();
      });
    }
    return { init: init };
  })();

  /* ============ EpGlosario — Modal con todos los términos ============ */
  var EpGlosario = (function () {
    var TERMS = [
      ['NEM', 'Promedio de Notas de Enseñanza Media transformado a puntaje 150-1000.'],
      ['Ranking', 'Puntaje (150-1000) que premia tu posición dentro de tu colegio.'],
      ['CLEC', 'Competencia Lectora — prueba obligatoria PAES.'],
      ['Matemática M1', 'Matemática obligatoria — junto con CLEC forma el "promedio obligatorias".'],
      ['Matemática M2', 'Matemática electiva avanzada — exigida o ponderada en algunas carreras.'],
      ['Ponderación', 'Porcentaje con que cada prueba pesa para calcular el puntaje ponderado. Suma 100%.'],
      ['Puntaje de corte ponderado', 'Menor puntaje ponderado de los matriculados regulares en la carrera. Calculado desde datos DEMRE y validado contra portales universitarios.'],
      ['Promedio CLEC + M1 del último seleccionado', 'Indicador oficial DEMRE. Promedio aritmético CLEC y M1 del último estudiante seleccionado.'],
      ['Puntaje mínimo para postular', 'Piso ponderado para postular. NO garantiza selección, solo permite postular.'],
      ['Promedio mínimo CLEC + M1', 'Piso de promedio CLEC + M1 para postular. Suele ser 458, 485 o 500 según la universidad.'],
      ['Vacantes', 'Cupos ofrecidos por la carrera en vía regular (1er + 2do semestre).'],
      ['PACE', 'Programa de Acompañamiento y Acceso Efectivo. Vía especial para colegios PACE.'],
      ['Código DEMRE', 'Identificador único de cada combinación carrera-universidad-sede.'],
      ['Electiva Ciencias/Historia', 'Cuando ambas tienen igual ponderación, NO se suman. Se usa automáticamente la que más te favorece.'],
      ['Percentil', 'Indica qué porcentaje de seleccionados está igual o por debajo de un puntaje. P50 = mediana.'],
      ['Área SIES', 'Clasificación oficial del Servicio de Información de la Educación Superior: Salud, Tecnología, Educación, Derecho, etc.'],
      ['Casa matriz', 'Sede principal de la universidad. La columna "Región casa matriz" no siempre coincide con dónde se imparte tu carrera.']
    ];
    function open() {
      if ($('#ep-paes-glosario-overlay')) return;
      var overlay = el('div', { id: 'ep-paes-glosario-overlay', class: 'ep-paes-glosario-overlay ep-paes-root' });
      var box = el('div', { class: 'ep-paes-glosario-box' });
      box.appendChild(el('button', { type: 'button', class: 'ep-paes-glosario-close', html: '✕',
        'aria-label': 'Cerrar',
        onclick: function () { overlay.remove(); }
      }));
      var ghead = el('div', { class: 'ep-paes-dialog-header' });
      ghead.appendChild(el('span', { class: 'ep-paes-dialog-chip', text: 'Glosario EurekaPAES' }));
      ghead.appendChild(el('h2', { class: 'ep-paes-glosario-title', text: 'Diccionario PAES' }));
      ghead.appendChild(el('p', { class: 'ep-paes-glosario-sub', text: 'Conceptos clave para entender puntajes, ponderaciones y admisión.' }));
      box.appendChild(ghead);
      var list = el('dl', { class: 'ep-paes-glosario-list' });
      TERMS.forEach(function (t) {
        list.appendChild(el('dt', { text: t[0] }));
        list.appendChild(el('dd', { text: t[1] }));
      });
      box.appendChild(list);
      overlay.appendChild(box);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
      document.body.appendChild(overlay);
    }
    return { open: open };
  })();

  /* ============ EpAlcanzo — Filtro "alcanzo hoy" ============ */
  var EpAlcanzo = (function () {
    function loadPuntajes() { return readJSON('ep_paes_puntajes_v1', {}); }
    function alcanza(carrera, puntajes) {
      /* Replica lógica computar() respetando electiva */
      var pond = carrera.ponderaciones || {};
      var keys = Object.keys(pond).filter(function (k) { return pond[k] > 0; });
      if (keys.length === 0) return false;
      var electiva = !!carrera.electiva_ciencias_historia;
      var faltan = [];
      keys.forEach(function (k) { if (puntajes[k] == null || isNaN(puntajes[k])) faltan.push(k); });
      if (electiva) {
        var hasC = puntajes.ciencias != null;
        var hasH = puntajes.historia != null;
        faltan = faltan.filter(function (k) { return k !== 'ciencias' && k !== 'historia'; });
        if (!hasC && !hasH) return false;
      }
      if (faltan.length > 0) return false;
      var total = 0;
      if (electiva) {
        var pct = pond.ciencias;
        var aC = puntajes.ciencias != null ? puntajes.ciencias * (pct / 100) : -Infinity;
        var aH = puntajes.historia != null ? puntajes.historia * (pct / 100) : -Infinity;
        total += Math.max(aC, aH);
      }
      keys.forEach(function (k) {
        if (electiva && (k === 'ciencias' || k === 'historia')) return;
        total += puntajes[k] * (pond[k] / 100);
      });
      var meta = (carrera.ponderado_ultimo_matriculado != null) ? carrera.ponderado_ultimo_matriculado : carrera.puntaje_corte_clec_m1;
      if (meta == null) return false;
      return total >= meta;
    }
    return {
      isActive: function () { return localStorage.getItem(LS.ALCANZO) === '1'; },
      setActive: function (v) { try { localStorage.setItem(LS.ALCANZO, v ? '1' : '0'); } catch (e) {} },
      alcanza: alcanza,
      hasPuntajes: function () {
        var p = loadPuntajes();
        return Object.keys(p).length >= 3; /* al menos 3 puntajes ingresados */
      },
      getPuntajes: loadPuntajes
    };
  })();

  /* ============ EpShareWA — Compartir favoritas por WhatsApp ============ */
  var EpShareWA = (function () {
    function buildLink() {
      var favs = readJSON('ep_paes_favs_v1', []);
      if (!favs.length) return null;
      var carreras = favs.map(findByCode).filter(Boolean);
      var lines = carreras.map(function (c, i) {
        return (i + 1) + '. ' + c.carrera + ' — ' + c.universidad + (c.sede ? ' (' + c.sede + ')' : '');
      });
      var msg = 'Estas son mis carreras favoritas PAES 2026 en EurekaPAES:\n\n' + lines.join('\n') + '\n\nPuedes revisar el buscador y armar las tuyas aquí: ' + WA_LINK + '?favs=' + favs.join(',');
      return 'https://wa.me/?text=' + encodeURIComponent(msg);
    }
    function render(host) {
      var link = buildLink();
      if (!link) return null;
      return el('a', {
        href: link,
        target: '_blank', rel: 'noopener noreferrer',
        class: 'ep-paes-share-wa-btn',
        html: '💬 Compartir por WhatsApp'
      });
    }
    return { render: render, buildLink: buildLink };
  })();

  /* ============ EpAlt — Carreras alternativas / similares (modal) ============ */
  var EpAlt = (function () {
    function ponderacionDistance(a, b) {
      /* Distancia simple entre vectores de ponderación */
      var keys = ['nem','ranking','competencia_lectora','matematica_m1','matematica_m2','ciencias','historia'];
      var d = 0;
      keys.forEach(function (k) {
        var va = (a && a[k]) || 0;
        var vb = (b && b[k]) || 0;
        d += Math.abs(va - vb);
      });
      return d;
    }
    function carrerasSimilares(c, maxN) {
      maxN = maxN || 6;
      var all = dataArr();
      if (!all.length) return [];
      var refPond = c.ponderaciones || {};
      var refMeta = c.ponderado_ultimo_matriculado || c.puntaje_corte_clec_m1 || 0;
      /* Score: misma área + similitud de ponderación + cercanía de puntaje */
      var scored = [];
      all.forEach(function (x) {
        if (x.codigo_demre === c.codigo_demre) return;
        var s = 0;
        if (x.area && c.area && x.area === c.area) s += 30;
        var dp = ponderacionDistance(refPond, x.ponderaciones);
        s += Math.max(0, 40 - dp * 0.5);  /* menor distancia → más puntos */
        var meta2 = x.ponderado_ultimo_matriculado || x.puntaje_corte_clec_m1;
        if (refMeta && meta2) {
          var diffM = Math.abs(refMeta - meta2);
          s += Math.max(0, 30 - diffM / 10);  /* dentro de 300 pts vale algo */
        }
        /* Bonus: misma universidad o nombre con palabra clave compartida */
        if (x.universidad === c.universidad) s += 5;
        var w1 = (c.carrera || '').toLowerCase().split(/\s+/);
        var w2 = (x.carrera || '').toLowerCase().split(/\s+/);
        var common = w1.filter(function (w) { return w.length > 3 && w2.indexOf(w) >= 0; }).length;
        s += common * 4;
        scored.push({ c: x, s: s });
      });
      scored.sort(function (a, b) { return b.s - a.s; });
      return scored.slice(0, maxN).map(function (o) { return o.c; });
    }
    function renderSeccion(c) {
      var sims = carrerasSimilares(c, 6);
      if (!sims.length) return null;
      var puntajes = readJSON('ep_paes_puntajes_v1', {});
      var hasPuntajes = Object.keys(puntajes).length > 0;
      var box = el('div', { class: 'ep-paes-alt-box' });
      box.appendChild(el('h4', { class: 'ep-paes-modal-h4', html: '<span>🔁</span> Carreras similares o alternativas' }));
      var grid = el('div', { class: 'ep-paes-alt-grid' });
      sims.forEach(function (s) {
        var card = el('div', { class: 'ep-paes-alt-card' });
        card.appendChild(el('div', { class: 'ep-paes-alt-card-titulo', text: s.carrera }));
        card.appendChild(el('div', { class: 'ep-paes-alt-card-uni', text: s.universidad }));
        var meta = (s.ponderado_ultimo_matriculado != null) ? s.ponderado_ultimo_matriculado : s.puntaje_corte_clec_m1;
        if (meta != null) {
          card.appendChild(el('div', { class: 'ep-paes-alt-card-pts', html: '<strong>' + fmtNum(meta) + '</strong> ' + (s.ponderado_ultimo_matriculado != null ? 'pond.' : 'CLEC+M1') }));
        }
        if (hasPuntajes && meta != null) {
          var tuPond = computeTuPond(s, puntajes);
          if (tuPond != null) {
            var d = Math.round((meta - tuPond) * 10) / 10;
            var cls = d <= 0 ? 'sobre' : (d <= 30 ? 'cerca' : (d <= 80 ? 'camino' : 'reforz'));
            card.appendChild(el('div', { class: 'ep-paes-alt-card-diff is-' + cls, text: d <= 0 ? '+' + Math.abs(d) + ' sobre meta' : 'Te faltan ' + d + ' pts' }));
          }
        }
        var actions = el('div', { class: 'ep-paes-alt-card-actions' });
        actions.appendChild(el('button', {
          type: 'button', class: 'ep-paes-alt-card-btn',
          text: 'Ver →',
          onclick: function () { if (window.EpPaesAbrirModal) window.EpPaesAbrirModal(s); }
        }));
        actions.appendChild(el('button', {
          type: 'button', class: 'ep-paes-alt-card-btn is-secondary',
          html: window.EpFavs && window.EpFavs.isFav(s.codigo_demre) ? '★' : '☆',
          title: 'Agregar/quitar de favoritos',
          onclick: function (ev) {
            ev.preventDefault(); ev.stopPropagation();
            if (window.EpFavs) {
              var was = window.EpFavs.isFav(s.codigo_demre);
              /* Acceder al toggle del módulo favoritos via la estrella oculta */
              var fav = readJSON('ep_paes_favs_v1', []);
              var idx = fav.indexOf(s.codigo_demre);
              if (idx >= 0) fav.splice(idx, 1); else fav.push(s.codigo_demre);
              writeJSON('ep_paes_favs_v1', fav);
              ev.target.innerHTML = idx >= 0 ? '☆' : '★';
              if (window.EpFavs.render) window.EpFavs.render();
              if (window.EpFavs.refreshAllStarsInDOM) window.EpFavs.refreshAllStarsInDOM();
            }
          }
        }));
        card.appendChild(actions);
        grid.appendChild(card);
      });
      box.appendChild(grid);
      return box;
    }
    function computeTuPond(c, puntajes) {
      var pond = c.ponderaciones || {};
      var keys = Object.keys(pond).filter(function (k) { return pond[k] > 0; });
      if (keys.length === 0) return null;
      var electiva = !!c.electiva_ciencias_historia;
      var faltan = [];
      keys.forEach(function (k) { if (puntajes[k] == null || isNaN(puntajes[k])) faltan.push(k); });
      if (electiva) {
        var hasC = puntajes.ciencias != null, hasH = puntajes.historia != null;
        faltan = faltan.filter(function (k) { return k !== 'ciencias' && k !== 'historia'; });
        if (!hasC && !hasH) return null;
      }
      if (faltan.length > 0) return null;
      var total = 0;
      if (electiva) {
        var pct = pond.ciencias;
        var aC = puntajes.ciencias != null ? puntajes.ciencias * (pct / 100) : -Infinity;
        var aH = puntajes.historia != null ? puntajes.historia * (pct / 100) : -Infinity;
        total += Math.max(aC, aH);
      }
      keys.forEach(function (k) {
        if (electiva && (k === 'ciencias' || k === 'historia')) return;
        total += puntajes[k] * (pond[k] / 100);
      });
      return Math.round(total * 10) / 10;
    }
    return { renderSeccion: renderSeccion, carrerasSimilares: carrerasSimilares, computeTuPond: computeTuPond };
  })();

  /* ============ EpCTA — CTA inteligente según prueba urgente ============ */
  var EpCTA = (function () {
    function detectarPruebaUrgente() {
      var puntajes = readJSON('ep_paes_puntajes_v1', {});
      var favs = readJSON('ep_paes_favs_v1', []).map(findByCode).filter(Boolean);
      if (favs.length === 0) return null;
      var keysPaes = ['nem','ranking','competencia_lectora','matematica_m1','matematica_m2','ciencias','historia'];
      /* Prioridad PRINCIPAL: promedio de ponderación entre favoritas.
         Empate 1: pondCount. Empate 2: gap del estudiante. */
      var pondTotal = {}, pondCount = {};
      keysPaes.forEach(function (k) { pondTotal[k] = 0; pondCount[k] = 0; });
      favs.forEach(function (c) {
        var pond = c.ponderaciones || {};
        keysPaes.forEach(function (k) {
          var pct = pond[k] || 0;
          if (pct === 0) return;
          pondTotal[k] += pct;
          pondCount[k]++;
        });
      });
      var maxK = null, maxProm = -1, maxCount = -1, maxGap = -1;
      keysPaes.forEach(function (k) {
        if (pondCount[k] === 0) return;
        var prom = pondTotal[k] / pondCount[k];
        var gap = puntajes[k] != null ? Math.max(0, 1000 - puntajes[k]) : 500;
        if (prom > maxProm ||
            (prom === maxProm && pondCount[k] > maxCount) ||
            (prom === maxProm && pondCount[k] === maxCount && gap > maxGap)) {
          maxK = k; maxProm = prom; maxCount = pondCount[k]; maxGap = gap;
        }
      });
      return maxK;
    }
    function labelPrueba(k) {
      var m = {nem:'NEM', ranking:'Ranking', competencia_lectora:'Competencia Lectora', matematica_m1:'Matemática M1', matematica_m2:'Matemática M2', ciencias:'Ciencias', historia:'Historia y CC. Sociales'};
      return m[k] || k;
    }
    function render() {
      var k = detectarPruebaUrgente();
      if (!k) return null;
      var box = el('div', { class: 'ep-paes-cta-inteligente' });
      box.appendChild(el('div', { class: 'ep-paes-cta-inteligente-tag', text: '⚡ Tu prueba más urgente según tus favoritas' }));
      box.appendChild(el('h3', { class: 'ep-paes-cta-inteligente-prueba', text: labelPrueba(k) }));
      box.appendChild(el('p', { class: 'ep-paes-cta-inteligente-texto', text: 'En EurekaPAES puedes reforzar esta prueba con cápsulas claras, guías tipo PAES y solucionarios paso a paso. Subir esta prueba mejora tu ponderado en varias de tus favoritas a la vez.' }));
      box.appendChild(el('a', {
        href: PREU_LINK, target: '_blank', rel: 'noopener noreferrer',
        class: 'ep-paes-cta-inteligente-btn',
        html: '🚀 Reforzar ' + escapeHtml(labelPrueba(k)) + ' con EurekaPAES'
      }));
      return box;
    }
    return { detectarPruebaUrgente: detectarPruebaUrgente, labelPrueba: labelPrueba, render: render };
  })();

  /* ============ EpClaseGratis — Banner clase gratis ============ */
  var EpClaseGratis = (function () {
    function render(carrera) {
      var pond = carrera.ponderaciones || {};
      var top = null, topVal = 0;
      Object.keys(pond).forEach(function (k) { if (pond[k] > topVal) { topVal = pond[k]; top = k; } });
      var topLabel = top ? EpCTA.labelPrueba(top) : 'tu prueba más importante';
      var box = el('div', { class: 'ep-paes-clase-gratis' });
      box.appendChild(el('div', { class: 'ep-paes-clase-gratis-icon', text: '🎁' }));
      box.appendChild(el('div', { class: 'ep-paes-clase-gratis-body' }, [
        el('h4', { text: '¿Quieres acercarte a esta carrera?' }),
        el('p', { html: 'Prueba <strong>gratis</strong> una cápsula de EurekaPAES y empieza por la prueba que más pondera aquí: <strong>' + escapeHtml(topLabel) + '</strong>.' }),
        el('a', {
          href: CLASE_GRATIS_LINK, target: '_blank', rel: 'noopener noreferrer',
          class: 'ep-paes-clase-gratis-btn',
          text: 'Ver clase gratis →'
        })
      ]));
      return box;
    }
    return { render: render };
  })();

  /* ============ EpInforme — Informe imprimible ============ */
  var EpInforme = (function () {
    function generar() {
      var favs = readJSON('ep_paes_favs_v1', []).map(findByCode).filter(Boolean);
      var puntajes = readJSON('ep_paes_puntajes_v1', {});
      var pruebaUrg = EpCTA.detectarPruebaUrgente();
      var now = new Date();
      var fecha = now.toLocaleDateString('es-CL', { year: 'numeric', month: 'long', day: 'numeric' });
      var html = '<!DOCTYPE html><html lang="es-CL"><head><meta charset="UTF-8"><title>Mi Informe PAES 2026 — EurekaPAES</title>';
      html += '<style>';
      html += 'body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Arial,sans-serif;color:#1F1F1F;background:#fff;padding:24px;max-width:780px;margin:0 auto;line-height:1.5;}';
      html += '.head{background:linear-gradient(135deg,#6F1E97,#54157A);color:#fff;border-radius:18px;padding:24px;margin-bottom:24px;}';
      html += '.head h1{margin:0 0 6px;font-size:28px;}';
      html += '.head .brand{display:inline-block;background:#FFD100;color:#1F1F1F;padding:4px 12px;border-radius:999px;font-weight:800;font-size:12px;margin-bottom:8px;}';
      html += '.head .meta{font-size:13px;opacity:.9;}';
      html += 'h2{color:#6F1E97;font-size:18px;border-bottom:2px solid #F1E6F8;padding-bottom:6px;margin:24px 0 12px;}';
      html += '.puntajes{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;}';
      html += '.puntajes .p{background:#F8F7FC;padding:10px;border-radius:8px;border:1px solid #E6E2EE;}';
      html += '.puntajes .p .lbl{font-size:10px;text-transform:uppercase;color:#5A5A66;font-weight:700;}';
      html += '.puntajes .p .val{font-size:22px;font-weight:800;color:#6F1E97;}';
      html += '.fav{background:#fff;border:1px solid #E6E2EE;border-radius:10px;padding:14px;margin-bottom:10px;page-break-inside:avoid;border-left:5px solid #6F1E97;}';
      html += '.fav h3{margin:0 0 4px;font-size:15px;}';
      html += '.fav .uni{color:#6F1E97;font-weight:600;font-size:13px;}';
      html += '.fav .meta{font-size:11px;color:#5A5A66;margin-top:4px;}';
      html += '.fav .row{display:flex;gap:14px;margin-top:8px;flex-wrap:wrap;}';
      html += '.fav .row .b{font-size:12px;}.fav .row .b strong{color:#6F1E97;font-size:14px;}';
      html += '.estado{display:inline-block;padding:3px 9px;border-radius:999px;font-size:10px;font-weight:800;text-transform:uppercase;letter-spacing:.3px;margin-top:6px;}';
      html += '.e-sobre{background:#DFF6E5;color:#1A9C5C;}';
      html += '.e-cerca{background:#DFF6F6;color:#00A3A6;}';
      html += '.e-camino{background:#FFF7CC;color:#8A6F00;}';
      html += '.e-reforz{background:#FFEEDC;color:#C5631B;}';
      html += '.e-datos{background:#ECEAF2;color:#5A5A66;}';
      html += '.e-sin{background:#F1E6F8;color:#6F1E97;}';
      html += '.cta{background:linear-gradient(135deg,#FFD100,#FFB800);padding:18px;border-radius:14px;text-align:center;margin-top:24px;}';
      html += '.cta h3{margin:0 0 8px;color:#1F1F1F;}';
      html += '.cta a{display:inline-block;background:#6F1E97;color:#fff;padding:10px 22px;border-radius:999px;font-weight:800;text-decoration:none;margin-top:6px;}';
      html += '.foot{text-align:center;font-size:11px;color:#5A5A66;margin-top:30px;border-top:1px solid #E6E2EE;padding-top:12px;}';
      html += '@media print{body{padding:0;}.cta a{box-shadow:none;}}';
      html += '@page{margin:18mm;}';
      html += '</style></head><body>';
      html += '<div class="head"><div class="brand">PREUNIVERSITARIO EUREKAPAES</div>';
      html += '<h1>Mi Informe PAES 2026</h1>';
      html += '<div class="meta">Generado el ' + escapeHtml(fecha) + '</div></div>';

      html += '<h2>🧠 Mis puntajes</h2><div class="puntajes">';
      var pruebasArr = [
        ['nem','NEM'],['ranking','Ranking'],['competencia_lectora','CLEC'],['matematica_m1','M1'],
        ['matematica_m2','M2'],['ciencias','Ciencias'],['historia','Historia']
      ];
      pruebasArr.forEach(function (p) {
        html += '<div class="p"><div class="lbl">' + escapeHtml(p[1]) + '</div><div class="val">' + (puntajes[p[0]] != null ? puntajes[p[0]] : '—') + '</div></div>';
      });
      html += '</div>';

      html += '<h2>⭐ Mis carreras favoritas (' + favs.length + ')</h2>';
      if (favs.length === 0) {
        html += '<p style="color:#5A5A66;">Aún no tienes favoritas guardadas.</p>';
      } else {
        favs.forEach(function (c) {
          var meta = c.ponderado_ultimo_matriculado != null ? c.ponderado_ultimo_matriculado : c.puntaje_corte_clec_m1;
          var tuPond = EpAlt.computeTuPond(c, puntajes);
          var diff = (tuPond != null && meta != null) ? Math.round((meta - tuPond) * 10) / 10 : null;
          var estado, estClass;
          if (tuPond == null) { estado = 'Completa tus puntajes'; estClass = 'e-datos'; }
          else if (meta == null) { estado = 'Sin meta ponderada'; estClass = 'e-sin'; }
          else if (diff <= 0) { estado = 'Sobre la meta'; estClass = 'e-sobre'; }
          else if (diff <= 30) { estado = 'Muy cerca'; estClass = 'e-cerca'; }
          else if (diff <= 80) { estado = 'En camino'; estClass = 'e-camino'; }
          else { estado = 'Falta reforzar'; estClass = 'e-reforz'; }
          html += '<div class="fav"><h3>' + escapeHtml(c.carrera) + '</h3>';
          html += '<div class="uni">' + escapeHtml(c.universidad) + '</div>';
          html += '<div class="meta">Código DEMRE ' + escapeHtml(c.codigo_demre) + (c.region ? ' · ' + escapeHtml(c.region) : '') + (c.sede ? ' · Sede ' + escapeHtml(c.sede) : '') + '</div>';
          html += '<span class="estado ' + estClass + '">' + estado + '</span>';
          html += '<div class="row">';
          html += '<div class="b">Tu ponderado: <strong>' + (tuPond != null ? tuPond : '—') + '</strong></div>';
          html += '<div class="b">Meta: <strong>' + (meta != null ? fmtNum(meta) : '—') + '</strong></div>';
          if (diff != null) html += '<div class="b">' + (diff <= 0 ? 'Margen' : 'Te faltan') + ': <strong>' + (diff <= 0 ? '+' + Math.abs(diff) : diff) + '</strong></div>';
          /* Prueba clave */
          var pondsKeys = c.ponderaciones ? Object.keys(c.ponderaciones) : [];
          if (pondsKeys.length) {
            var topK = pondsKeys.reduce(function (a, b) { return c.ponderaciones[a] > c.ponderaciones[b] ? a : b; });
            html += '<div class="b">Prueba clave: <strong>' + escapeHtml(EpCTA.labelPrueba(topK)) + ' (' + c.ponderaciones[topK] + '%)</strong></div>';
          }
          html += '</div></div>';
        });
      }

      if (pruebaUrg) {
        html += '<h2>🎯 Tu plan de ataque</h2>';
        html += '<p>Según tus favoritas y tus puntajes actuales, <strong>tu prueba más urgente es ' + escapeHtml(EpCTA.labelPrueba(pruebaUrg)) + '</strong>.</p>';
        html += '<p style="color:#5A5A66;font-size:13px;">Esta es la prueba con mayor impacto combinado entre las ponderaciones de tus favoritas y la distancia a tus puntajes actuales. Reforzarla puede mejorar tu ponderado en varias carreras al mismo tiempo.</p>';
      }

      html += '<div class="cta"><h3>¿Listo para reforzar tu PAES?</h3>';
      html += '<p style="margin:0 0 6px;">EurekaPAES tiene clases grabadas, +110 guías con solucionarios paso a paso, ensayos y mini-quiz.</p>';
      html += '<a href="' + PREU_LINK + '">🚀 Prepararme con EurekaPAES</a></div>';

      html += '<div class="foot">Datos oficiales DEMRE Admisión 2026 · Buscador local EurekaPAES · Los puntajes de corte son referenciales y pueden variar cada año.</div>';
      html += '</body></html>';

      var w = window.open('', '_blank');
      if (!w) {
        alert('Tu navegador bloqueó la ventana del informe. Permite ventanas emergentes y vuelve a intentarlo.');
        return;
      }
      w.document.open();
      w.document.write(html);
      w.document.close();
      setTimeout(function () { try { w.focus(); w.print(); } catch (e) {} }, 500);
    }
    return { generar: generar };
  })();

  /* ============ EpPopulares — Marcar carreras con más vacantes ============ */
  var EpPopulares = (function () {
    var TOP = {}; /* codigo_demre → true si está entre las top vacantes */
    function compute() {
      var all = dataArr();
      if (!all.length) return;
      var sorted = all.slice().sort(function (a, b) { return (b.vacantes || 0) - (a.vacantes || 0); });
      sorted.slice(0, 50).forEach(function (c) { TOP[c.codigo_demre] = true; });
    }
    function isPopular(cod) { return !!TOP[cod]; }
    return { compute: compute, isPopular: isPopular };
  })();

  /* ============ EpBuscaInt — Sugerencias relacionadas ============ */
  var EpBuscaInt = (function () {
    var GRUPOS = [
      { trigger: ['medicina','médico'], related: ['Enfermería','Tecnología Médica','Obstetricia','Kinesiología','Odontología','Nutrición','Medicina Veterinaria','Bachillerato en Salud'] },
      { trigger: ['derecho','abogado'], related: ['Ciencia Política','Administración Pública','Trabajo Social','Sociología','Periodismo'] },
      { trigger: ['ingeniería civil','ingeniería'], related: ['Ingeniería en Ejecución','Construcción Civil','Ingeniería Comercial','Bachillerato en Ciencias e Ingeniería'] },
      { trigger: ['psicología','psicologia'], related: ['Trabajo Social','Sociología','Educación Diferencial','Terapia Ocupacional','Fonoaudiología'] },
      { trigger: ['arquitectura'], related: ['Diseño','Construcción Civil','Diseño Industrial','Urbanismo'] },
      { trigger: ['comercial','negocios','administración'], related: ['Contador Auditor','Ingeniería en Información y Control de Gestión','Economía','Marketing'] },
      { trigger: ['profesor','pedagogía','pedagogia'], related: ['Educación Diferencial','Educación Parvularia','Psicopedagogía'] }
    ];
    function buscarRelacionadas(q) {
      var qn = (q || '').toLowerCase();
      if (qn.length < 3) return [];
      for (var i = 0; i < GRUPOS.length; i++) {
        var g = GRUPOS[i];
        for (var j = 0; j < g.trigger.length; j++) {
          if (qn.indexOf(g.trigger[j]) >= 0) return g.related;
        }
      }
      return [];
    }
    return { buscarRelacionadas: buscarRelacionadas };
  })();

  /* ============ Microcopy motivador ============ */
  var MICROCOPY = {
    sobre:  ['Vas muy bien para esta carrera.','Estás sobre la meta. Mantén el ritmo.','Tu momento Eureka está cerca.'],
    cerca:  ['Estás a pocos puntos. Enfócate en tu prueba clave.','Casi en la meta. Cada punto cuenta ahora.','Muy cerca. Un último empujón.'],
    camino: ['Todavía puedes acercarte con una estrategia clara.','Vas por buen camino. Foco en lo que más pondera.','No se trata de estudiar más al azar, sino con estrategia.'],
    reforz: ['Todavía falta, pero ya sabes dónde enfocarte.','Tu camino empieza por reforzar la prueba que más pondera.','Esta carrera es desafiante, pero ahora tienes claro qué prueba mover primero.','Conviene priorizar las pruebas con mayor ponderación.']
  };
  function microcopy(estado) {
    var arr = MICROCOPY[estado];
    if (!arr || !arr.length) return null;
    return arr[Math.floor(Math.random() * arr.length)];
  }

  /* ============ EXPORT ============ */
  window.EpExtras = {
    Url: EpUrl,
    Recientes: EpRecientes,
    Onboard: EpOnboard,
    Tooltip: EpTooltip,
    Glosario: EpGlosario,
    Alcanzo: EpAlcanzo,
    ShareWA: EpShareWA,
    Alt: EpAlt,
    CTA: EpCTA,
    ClaseGratis: EpClaseGratis,
    Informe: EpInforme,
    Populares: EpPopulares,
    BuscaInt: EpBuscaInt,
    microcopy: microcopy
  };

  /* ============ INIT ============ */
  function init() {
    EpTooltip.init();
    EpOnboard.init();
    EpUrl.handleInitial();
    /* Computar populares cuando los datos estén listos */
    var attempts = 0;
    var t = setInterval(function () {
      if (dataArr().length) {
        EpPopulares.compute();
        EpRecientes.render();
        clearInterval(t);
      } else if (++attempts > 30) clearInterval(t);
    }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();